import { SquareArrowOutUpRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { Badge } from '@/components/ui/badge';
import { selectAccountSlug } from '@/redux/session/selectors';
import type { ContactMemory, MemoryCategory } from '@/shared/types/contacts';
import { timeFromNowShort } from '@/util/dateUtils';

interface MemoryCardProps {
  memory: ContactMemory;
}

export const memoryCategoryLabelKey: Record<MemoryCategory, string> = {
  fact: 'contacts.fact',
  preference: 'contacts.preference',
};

export const MemoryCard = ({ memory }: MemoryCardProps) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);

  const sessionUrl =
    slug && memory.session_id
      ? `/${slug}/analytics/account-chat-logs?session_id=${memory.session_id}`
      : null;

  return (
    <div className="flex w-full max-w-xl flex-col gap-3 pb-4">
      <div className="flex items-start justify-between gap-3">
        <h3 className="flex-1 text-sm leading-6 font-normal text-foreground">{memory.content}</h3>
        <Badge type="outline" flavour="ai" rounded={false} className="font-semibold">
          {t(memoryCategoryLabelKey[memory.category])}
        </Badge>
      </div>
      <div className="flex items-center justify-between gap-3">
        {sessionUrl ? (
          <Link
            to={sessionUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 text-sm font-medium text-foreground-muted hover:text-foreground"
          >
            {t('contacts.view')}
            <SquareArrowOutUpRightIcon size={16} />
          </Link>
        ) : (
          <span />
        )}
        <span className="text-sm text-foreground-muted">{timeFromNowShort(memory.updated)}</span>
      </div>
    </div>
  );
};
